import type { IconName } from "@assetwatch/ui";

export function formatMarketplaceDate(
  value: string | null,
  notApplicable: string,
  locale: string,
) {
  if (!value) return notApplicable;
  const date = new Date(value);
  return Number.isNaN(date.valueOf())
    ? value
    : new Intl.DateTimeFormat(locale, {
        month: "short",
        day: "numeric",
        year: "numeric",
      }).format(date);
}

export function formatMarketplaceCurrency(value: number, locale: string) {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(value);
}

export function getMarketplaceIcon(type: string, name: string): IconName {
  const normalizedType = type.toLowerCase();
  const normalizedName = name.toLowerCase();
  if (
    normalizedType.includes("oil") ||
    normalizedName.includes("oil analysis")
  ) {
    return "oil-analysis-bottle";
  }
  if (normalizedType.includes("vibration")) return "vibration";
  if (normalizedType.includes("hardware")) return "hardware";
  return "marketplace";
}
